import CreateMockTest from '@/features/create-practice-test'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/create-practice-test/$moduleId/$classId')({
  component: CreateMockTestWrapper,
})

function CreateMockTestWrapper() {
  const { moduleId, classId } = Route.useParams() as { moduleId: string; classId: string }
  return <CreateMockTest key={`${moduleId}-${classId}`} moduleId={moduleId} classId={classId} />
}

export default Route